import styled from "styled-components";
import ChargeListInputTable from "./chargeListInputTable";
import TableItem from "./tableItem";
import { useEffect } from "react";
import CellComponent from "./cellComponent";
import { text } from "stream/consumers";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 87vw;
  height: 110vw;
  /* height: 123vw; */
`;

const DataInputArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 3vw;
  margin-bottom: 1vw;
  /* border: 0.1vw solid black; */
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 3vw;
  /* border: 0.1vw solid black; */
`;

const ContentsArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 110vw;
  /* background-color: aliceblue; */
  margin-top: 0.2vw;
`;

const ChargeContentsArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 87vw;
  /* background-color: #e0e0e0; */
`;

const SumContentsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const LeftSideArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.8vw;
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: none;
  background-color: #f4f4f4;
  font-size: 1.8vw;
  font-weight: 600;
  padding: 1vw;
  line-height: 3vw;
`;

const RightSideArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  height: 100%;
`;

const HeaderItem = styled.div<{
  width?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6vw;
  font-weight: 600;
  width: ${(props) => props.width};
  height: 100%;
  border-top: 0.1vw solid #606060;
  border-bottom: 0.1vw solid #606060;
  border-left: 0.1vw solid #606060;
  border-right: ${(props) => (props.$isLast ? "0.1vw solid #606060;" : "")};
  background-color: #f4f4f4;
`;

const HeaderItemInput = styled.input<{
  width?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6vw;
  font-weight: 600;
  width: ${(props) => props.width};
  height: 100%;
  border: none;
  border-top: 0.1vw solid #606060;
  border-bottom: 0.1vw solid #606060;
  border-right: ${(props) => (props.$isLast ? "0.1vw solid #606060;" : "")};
  text-align: center;

  &:focus {
    outline: none; /* 포커스 스타일 제거 */
  }
`;

const SumInputRow = styled.div<{
  height?: string;
}>`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: ${(props) => (props.height ? props.height : "3vw")};
`;

const SumNameArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: start;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  background-color: #f4f4f4;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  font-size: 1.8vw;
  font-weight: 500;
  padding-left: 1.4vw;
  letter-spacing: 0.2vw;
`;

const SumDisplayArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: end;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 0.8vw;
  letter-spacing: 0.2vw;
`;

const SumInputArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
`;

const SumInputBox = styled.input<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 0.8vw;
  letter-spacing: 0.2vw;
`;

const SumInputSelectionBox = styled.div<{}>`
  display: flex;
  justify-content: end;
  align-items: center;
  z-index: 999;
  border: 1px solid red;
`;

const SumRemarkArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  letter-spacing: 0.2vw;
`;

export default function InputChargeComponent(props: any) {
  const { data, setData, currentPage, computeTotal } = props;
  const onChangeInput = (e: any) => {
    const inputValue = e.target.value;
    const name = e.target.name;
    setData((prev: any) => {
      const updatedData = { ...prev };
      updatedData.chargeList[currentPage - 1][name] = inputValue;

      return updatedData;
    });
  };

  return (
    <Wrapper>
      <DataInputArea>
        <HeaderItem width={"10vw"} $isLast>
          품명
        </HeaderItem>
        <HeaderItemInput
          value={data.name}
          name={"name"}
          onChange={onChangeInput}
          width={"14vw"}
        ></HeaderItemInput>
        <HeaderItem width={"12vw"} $isLast>
          작업구분
        </HeaderItem>
        <HeaderItemInput
          value={data.category}
          name={"category"}
          onChange={onChangeInput}
          width={"14vw"}
        ></HeaderItemInput>
        <HeaderItem width={"12vw"} $isLast>
          작업내용
        </HeaderItem>
        <HeaderItemInput
          value={data.contents}
          name={"contents"}
          onChange={onChangeInput}
          width={"14vw"}
        ></HeaderItemInput>
        <HeaderItem width={"10vw"} $isLast>
          비고
        </HeaderItem>
        <HeaderItemInput
          value={data.remark}
          name={"remark"}
          onChange={onChangeInput}
          width={"8vw"}
          $isLast
        ></HeaderItemInput>
      </DataInputArea>
      <HeaderArea>
        <HeaderItem width={"24vw"}>항 목</HeaderItem>
        <HeaderItem width={"15vw"}>규 격</HeaderItem>
        <HeaderItem width={"6vw"}>단위</HeaderItem>
        <HeaderItem width={"6vw"}>수량</HeaderItem>
        <HeaderItem width={"15vw"}>단가</HeaderItem>
        <HeaderItem width={"15vw"}>금액</HeaderItem>
        <HeaderItem width={"6vw"} $isLast={true}>
          비고
        </HeaderItem>
      </HeaderArea>
      <ContentsArea>
        <ChargeContentsArea>
          <LeftSideArea>순용역원가</LeftSideArea>
          <RightSideArea>
            <ChargeListInputTable
              idx={1}
              data={data.materialCost}
              setData={setData}
              currentPage={currentPage}
              name={`data.materialCost.List`}
            ></ChargeListInputTable>
            <ChargeListInputTable
              idx={2}
              data={data.movingCost}
              setData={setData}
              currentPage={currentPage}
              name={`data.movingCost.List`}
            ></ChargeListInputTable>
            <ChargeListInputTable
              idx={3}
              data={data.laborCost}
              setData={setData}
              currentPage={currentPage}
              name={`data.laborCost.List`}
            ></ChargeListInputTable>
            <ChargeListInputTable
              idx={4}
              data={data.ectCost}
              setData={setData}
              currentPage={currentPage}
              name={`data.ectCost.List`}
            ></ChargeListInputTable>
          </RightSideArea>
        </ChargeContentsArea>
        <SumContentsArea>
          <SumInputRow>
            <SumNameArea width={`51.06vw`}>5. 합계</SumNameArea>
            <SumDisplayArea width={`30.02vw`}>{data.total}</SumDisplayArea>
            <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
          </SumInputRow>
          <SumInputRow>
            <SumNameArea width={`39.1vw`}>6. 공과잡비</SumNameArea>
            <CellComponent
              width={"6vw"}
              value={data.expensesRate}
              name={`data.expensesRate`}
              currentPage={currentPage}
              setData={setData}
              computeTotal={computeTotal}
              idx={0}
              type={"number"}
            ></CellComponent>
            <CellComponent
              width={"6vw"}
              value={"%"}
              idx={0}
              type={"string"}
              readOnly
            ></CellComponent>
            <SumDisplayArea width={`30.02vw`}>{data.expenses}</SumDisplayArea>
            <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
          </SumInputRow>
          <SumInputRow>
            <SumNameArea width={`39.1vw`}>7. 일반관리비</SumNameArea>
            <CellComponent
              width={"6vw"}
              value={data.commonCostRate}
              name={`data.commonCostRate`}
              currentPage={currentPage}
              setData={setData}
              computeTotal={computeTotal}
              idx={0}
              type={"number"}
            ></CellComponent>
            <CellComponent
              width={"6vw"}
              value={"%"}
              idx={0}
              type={"string"}
              readOnly
            ></CellComponent>
            <SumDisplayArea width={`30.02vw`}>{data.commonCost}</SumDisplayArea>
            <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
          </SumInputRow>
          <SumInputRow>
            <SumNameArea width={`39.1vw`}>8. 이 윤</SumNameArea>
            <CellComponent
              width={"6vw"}
              value={data.profitRate}
              name={`data.profitRate`}
              currentPage={currentPage}
              setData={setData}
              computeTotal={computeTotal}
              idx={0}
              type={"number"}
            ></CellComponent>
            <CellComponent
              width={"6vw"}
              value={"%"}
              idx={0}
              type={"string"}
              readOnly
            ></CellComponent>
            <SumDisplayArea width={`30.02vw`}>{data.profit}</SumDisplayArea>
            <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
          </SumInputRow>
          <SumInputRow>
            <SumNameArea width={`51.06vw`}>9. 총 용역원가</SumNameArea>
            <SumDisplayArea width={`30.02vw`}>
              {data.totalServiceCost}
            </SumDisplayArea>
            <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
          </SumInputRow>
          <SumInputRow height={`4vw`}>
            <SumNameArea width={`51.06vw`} $isLast>
              10. 견적가
            </SumNameArea>
            <SumDisplayArea width={`30.02vw`} $isLast>
              {data.quotedPrice}
            </SumDisplayArea>
            <SumRemarkArea width={`5.92vw`} $isLast></SumRemarkArea>
          </SumInputRow>
        </SumContentsArea>
      </ContentsArea>
    </Wrapper>
  );
}
